import styled, { css } from 'styled-components'
import { Overlay } from 'styles/misc'
import { mq } from 'styles/mq'

export const IframeContainer = styled.div`
  position: relative;

  &::before {
    content: '';
    display: block;
    padding-top: 62.5%;
  }

  iframe {
    ${Overlay}
  }
`

export const ArticleContent = styled.main<{ withMargins?: boolean }>`
  ${props =>
    props.withMargins &&
    css`
      margin: 5rem 0 2rem;

      ${mq.medium} {
        margin: 10rem 0 6rem;
      }
    `}

  h2 {
    font-size: 2.5rem;
    font-weight: normal;

    ${mq.medium} {
      font-size: 4.5rem;
    }
  }

  h3,
  p {
    max-width: 82rem;
  }

  h3 {
    margin: 1.8em 0 0.5em;
  }

  figure,
  img,
  video,
  ${IframeContainer} {
    display: block;
    width: 100%;
    max-width: 103rem;
    margin: 4rem 0;
  }

  figure img {
    margin: 0;
  }

  figure.custom-image-side-left {
    margin: 0 2rem 0 0;

    ${mq.medium} {
      float: left;
      max-width: 30rem;
    }

    ${mq.large} {
      margin: 0 2rem 0 0;
    }
  }

  figcaption {
    font-size: 1.4rem;
    margin: 1rem 0;
    opacity: 0.8;

    ${mq.medium} {
      font-size: 1.8rem;
    }
  }
`
